import axios from 'axios'
import Global from '@/global'
import Vue from 'vue'
import { dissoc } from 'ramda'
import i18n from '@/i18n'

const initialState = () => ({
  iptVal: '',
  tagList: [],
})

const state = initialState()

const getters = {
  tagChecked(state) {
    return state.tagList.filter(el => el.checked)
  },
  tagListByIptVal(state) {
    return state.tagList.filter(el => ~el.name.indexOf(state.iptVal))
  }
}

const mutations = {
  resetState (state) {
    const initial = initialState()
    Object.keys(initial).forEach(key => { state[key] = initial[key] })
  },
  setIptVal(state, val) {
    state.iptVal = val
  },
  setTagList(state, data) {
    state.tagList = data
  },
  unshiftTagList(state, data) {
    state.tagList.unshift(data)
  },
  checkTag(state, id) {
    const index = state.tagList.findIndex(el => el.id === id)
    Vue.set(state.tagList, index, {
      ...state.tagList[index],
      checked: true
    })
  },
  toggleCheckTag(state, id) {
    const index = state.tagList.findIndex(el => el.id === id)
    if (
      !state.tagList[index].checked &&
      state.tagList.filter(el => el.checked).length === 5
    ) {
      return Vue.prototype.$message.warn(i18n.tc('home.More5Types'))
    }
    Vue.set(state.tagList, index, {
      ...state.tagList[index],
      checked: !state.tagList[index].checked
    })
  },
  clearChecked(state) {
    state.tagList.forEach((el, idx) => {
      Vue.set(state.tagList, idx, dissoc('checked', el))
    })
  }
}

const actions = {
  async queryTagList({ state, commit }) {
    try {
      const result = await axios.get(`/hiapigw/app/tag/search?name=${state.iptVal}&_id=${Global.genNonce(5)}`)
      if (result.data.code === 0) {
        commit('setTagList', result.data.data.list)
      } else {
        Vue.prototype.$message.error(result.data.comment)
      }
    } catch (err) {
      console.warn(err)
    }
  },
  addTag({ state, commit }, name) {
    return new Promise((resolve, reject) => {
      return axios.post(
        '/hiapigw/app/tag/create',
        { name },
        {
          params: {
            _id: Global.genNonce(5)
          }
        }
      )
        .then(result => {
          if (result.data.code === 0) {
            commit('unshiftTagList', { ...result.data.data.tagInfo, checked: true })
            Vue.prototype.$message.success(i18n.tc('home.AddTypeSucc'))
            resolve()
          } else {
            Vue.prototype.$message.warn(
              (result.data.msg === '类型添加重复' && result.data.code === 22002)
                ? i18n.tc('home.NotAddTypeOfExist')
                : result.data.msg
            )
            reject(result.data.msg)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
